import React, { useState } from 'react'
import { Search, X } from 'lucide-react'
import { useTranslation } from '../../hooks/useTranslation'
import arTranslations from '../../lang/ar.json'
import enTranslations from '../../lang/en.json'
import SearchSuggestions from '../search/SearchSuggestions'

const SearchBar: React.FC = () => {
  const [query, setQuery] = useState('')
  const [isFocused, setIsFocused] = useState(false)
  const { t, isRTL, currentLanguage } = useTranslation()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (query.trim()) {
      const raw = query.trim()
      const qLower = raw.toLowerCase()

      // Try to map the query to a known product slug via translations (AR/EN)
      const dicts = [
        currentLanguage === 'ar' ? arTranslations : enTranslations,
        currentLanguage === 'ar' ? enTranslations : arTranslations,
      ]
      let matchedSlug: string | undefined
      for (const dict of dicts) {
        const products: any = (dict as any)?.products || {}
        for (const [slug, info] of Object.entries(products)) {
          const name = (info as any)?.name as string | undefined
          const desc = (info as any)?.description as string | undefined
          if (
            (name && (name.toLowerCase?.().includes(qLower) || name.includes(raw))) ||
            (desc && (desc.toLowerCase?.().includes(qLower) || desc.includes(raw)))
          ) {
            matchedSlug = slug
            break
          }
        }
        if (matchedSlug) break
      }

      const target = matchedSlug ?? raw
      const q = encodeURIComponent(target)
      window.location.href = `/catalog?q=${q}`
    }
  }

  const clearQuery = () => {
    setQuery('')
  }

  return (
    <div className="relative w-full group">
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative flex items-center">
          
          {/* الزخرفة التراثية: إطار الإدخال المحسن */}
          <div className={`relative w-full rounded-lg transition-all duration-300 ${
            isFocused 
              ? 'shadow-[0_0_15px_rgba(212,175,55,0.15)] border-gold' 
              : 'border-border hover:border-gold/50'
          } border bg-surface-soft`}>

            {/* تفاصيل زخرفية هادئة على الزوايا عند التركيز */}
            <span className={`absolute -top-1 w-2 h-2 border-t-2 border-gold transition-opacity duration-300 ${isRTL ? '-right-1 border-r-2' : '-left-1 border-l-2'} ${isFocused ? 'opacity-100' : 'opacity-0'}`} />
            <span className={`absolute -bottom-1 w-2 h-2 border-b-2 border-gold transition-opacity duration-300 ${isRTL ? '-left-1 border-l-2' : '-right-1 border-r-2'} ${isFocused ? 'opacity-100' : 'opacity-0'}`} />

            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setTimeout(() => setIsFocused(false), 200)}
              placeholder={t('navbar.mainNav.search.placeholder')}
              className={`w-full py-2.5 bg-transparent text-text placeholder-text-2/60 text-sm focus:outline-none transition-colors ${
                isRTL ? 'pr-10 pl-10' : 'pl-10 pr-10'
              }`}
            />

            {/* زر المسح */}
            {query && (
              <button
                type="button"
                onClick={clearQuery}
                className={`absolute top-1/2 transform -translate-y-1/2 text-text-2 hover:text-gold transition-colors duration-150 ${
                  isRTL ? 'left-3' : 'right-3'
                }`}
                title={t('navbar.mainNav.search.clear')}
              >
                <X size={16} />
              </button>
            )}

            {/* أيقونة البحث كزر تفاعلي مذهب */}
            <button
              type="submit"
              className={`absolute top-1/2 transform -translate-y-1/2 p-1 text-text-2 hover:text-gold transition-colors duration-150 ${
                isRTL ? 'right-2' : 'left-2'
              }`}
            >
              <Search size={18} className={isFocused ? 'text-gold' : 'text-text-2'} />
            </button>
            
          </div>
        </div>
      </form>

      {/* اقتراحات البحث */}
      {isFocused && query.length > 1 && (
        <div className="absolute top-full mt-2 w-full z-50">
          <SearchSuggestions query={query} />
        </div>
      )}
    </div>
  )
}

export default SearchBar